import styled from 'styled-components'
import { theme } from '../../../../styles/theme'

export const Container = styled.button`
  width: 100%;
  margin: 5px 0px 0px;

  text-align: end;

  font-family: ${theme.font.inter};
  font-size: ${theme.font.sizes.small};
  line-height: 17px;
  text-decoration: underline;
  color: ${theme.colors.black};
  background: none;
  text-decoration: underline;
  cursor: pointer;
`
